var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.rootClass},[_c('div',{ref:"visualElement",class:[
      `${_vm.rootClass}__blur`,
      _vm.tallView ? `${_vm.rootClass}__blur--tall-view` : '',
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }